module.exports = __webpack_public_path__ + "0bd701b6f6e77ca1716321bf823a6315.jpg";